export type RequestDetailSearch = { ticket?: string };

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const requestDetailSearch = (search: Record<string, unknown>): RequestDetailSearch => ({
  ticket: typeof search.ticket === "string" && UUID.test(search.ticket) ? search.ticket : undefined,
});
